import React, { Component } from 'react';
import { PieChart, Pie, Cell, Tooltip } from 'recharts';

const COLORS = ['#2c4bff', '#e0e0e0'];

class OpbItemPieChart extends Component {

  render() {
    const { data } = this.props;
    return (
      <PieChart width={150} height={150}>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          startAngle={90}
          endAngle={450}
          innerRadius={45}
          outerRadius={60}
          dataKey="value"
        >
          {
            data.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />)
          }
        </Pie>
        <Tooltip content={<CustomTooltip />} active={true} />
      </PieChart>
    );
  }
}

export default OpbItemPieChart;

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length && payload[0].name === "연결") {
    return (
      <div className="custom-tooltip" style={{ backgroundColor: "#ffffff", border: "1px solid black", padding: "5px" }}>
        {`${payload[0].name} : ${payload[0].value}`}
      </div>
    );
  }

  return null;
};